export default {
  partners: {
    en: 'Partners',
    fr: 'Partenaires',
  },
  partner_principal: {
    en: 'Principal Partners',
    fr: 'Partenaires Principal',
  },
  partner_platinum: {
    en: 'Platinum Partners',
    fr: 'Partenaires Platine',
  },
  partner_gold: {
    en: 'Gold Partners',
    fr: 'Partenaires Or',
  },
  partner_silver: {
    en: 'Silver Partners',
    fr: 'Partenaires Argent',
  },
  partner_bronze: {
    en: 'Bronze Partners',
    fr: 'Partenaires Bronze',
  },
};
